import React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonVariant,
    H6Emphasized,
    Sheet,
    YStack,
} from 'smoothie';

interface IncomeSplitContributionSheetProps {
    isOpen: boolean;
    onClose: () => void;
    contributionMaxType: string | null;
}

const IncomeSplitContributionSheet = ({
    isOpen,
    onClose,
    contributionMaxType,
}: IncomeSplitContributionSheetProps) => {
    if (contributionMaxType == null) return null;

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            showCloseButton={false}
            isInsideModal
        >
            <YStack gap={14} paddingTop={20} maxWidth={500}>
                <H6Emphasized>{contributionMaxType} limit</H6Emphasized>
                <BodyMediumRegular color="$gray900">
                    We&apos;ll track a running total of any contributions made
                    from prior Income Splits between the first and last day of
                    the calendar{' '}
                    {contributionMaxType === 'Monthly' ? 'month' : 'year'}.
                    Contributions and limits are calculated for each rule
                    individually.
                </BodyMediumRegular>

                <BodyMediumRegular color="$gray900">
                    Once you&apos;ve reached the{' '}
                    {contributionMaxType.toLowerCase()} limit, no further
                    contributions will be made until the following{' '}
                    {contributionMaxType === 'Monthly' ? 'month' : 'year'}.
                </BodyMediumRegular>
                <Button
                    marginTop={16}
                    text="Dismiss"
                    variant={ButtonVariant.PRIMARY}
                    onPress={onClose}
                />
            </YStack>
        </Sheet>
    );
};

export default IncomeSplitContributionSheet;
